import React from 'react'
import { Container, Typography, Box, Divider, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import { CookieService } from '../../lib/utils'
import { HOME_PATH } from '../../routes/constants.routes'
import { ArrowLeftIcon } from '../../asterX-UI/Icons'
import { useRoutes } from '../../lib/hooks'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 32,
    marginBottom: 64
  },
  section: {
    marginBottom: 40
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: GRAY_COLORS[900],
    marginBottom: 16
  },
  subtitle: {
    fontSize: 18,
    fontWeight: 500,
    color: PRIMARY_COLORS[700],
    marginBottom: 12
  },
  text: {
    fontSize: 14,
    fontWeight: 400,
    color: GRAY_COLORS[800],
    lineHeight: 1.6
  },
  divider: {
    margin: '32px 0'
  }
}))

const OnlineSigningInfoPage = () => {
  const classes = useStyles()
  const router = useRoutes()
  return (
    <Container className={classes.root} maxWidth="md">
      <Button style={{ padding: 0, marginBottom: 16 }} onClick={() => {
        CookieService.deleteCookieEverywhere('infoScreen')
        router.goTo(HOME_PATH)
      }}>
        <ArrowLeftIcon /> Назад
      </Button>
      <Box className={classes.section}>
        <Typography className={classes.title}>Онлайн-подписание документов</Typography>
        <Typography className={classes.text}>
          Сервис онлайн-подписания — это удобный и безопасный способ
          подписывать юридически значимые документы в электронном
          виде, не выходя из дома или офиса.
        </Typography>
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography className={classes.subtitle}>Преимущества для клиента</Typography>
        <ul className={classes.text}>
          <li>Экономия времени — не нужно посещать офис.</li>
          <li>Доступность 24/7 с любого устройства.</li>
          <li>Уведомления и напоминания о статусе документа.</li>
          <li>Юридическая сила документов, подписанных ЭЦП.</li>
        </ul>
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography className={classes.subtitle}>Как проходит процесс подписания</Typography>
        <Typography className={classes.text}>
          1. Клиент получает ссылку на документ или входит в личный кабинет.<br />
          2. Ознакамливается с содержимым документа.<br />
          3. Подписывает с помощью ЭЦП или подтверждения через SMS/QR.<br />
          4. Получает подтверждение и доступ к подписанному документу.
        </Typography>
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography className={classes.subtitle}>Безопасность и юридическая значимость</Typography>
        <Typography className={classes.text}>
          Наш сервис соответствует всем требованиям законодательства Республики
          Казахстан в сфере электронного документооборота. Используются сертифицированные
          методы шифрования и электронные цифровые подписи.
        </Typography>
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography className={classes.subtitle}>Часто задаваемые вопросы</Typography>
        <Typography className={classes.text}>
          <strong>Нужна ли мне специальная программа для подписания?</strong><br />
          Нет, достаточно браузера и доступа к интернету.<br /><br />

          <strong>Можно ли подписать документ с телефона?</strong><br />
          Да, наш сервис полностью адаптирован под мобильные устройства.<br /><br />

          <strong>Подписи действительно юридически?</strong><br />
          Да, мы используем ЭЦП, которая признается законом.
        </Typography>
      </Box>
    </Container>
  )
}

export default OnlineSigningInfoPage
